var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showCorporateMessage
      ? _c("div", [_c("p", [_vm._v("Corporate exclusive.")])])
      : _vm._e(),
    _vm._v(" "),
    _vm.showB2BMessage
      ? _c("div", [_c("p", [_vm._v("Not available for corporate orders.")])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }